import React from "react";
import {Button} from "@unibuddy/patron";
import styled from "styled-components";

const StyledButton = styled(Button)`
    color: #306fae;
    font-family: Nunito;
    font-size: 1rem;
`;

declare global {
    interface Window {
        OneTrust: {
            ToggleInfoDisplay: () => void;
        };
    }
}

export function CookieSettings() {
    return (
        <StyledButton link onClick={() => window.OneTrust.ToggleInfoDisplay()}>
            Cookie settings
        </StyledButton>
    );
}
